/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IHosportsAccessibilityWidgetData } from './hosports-accessibility-widget.data';
import { IHosportsAccessibilityWidgetProps } from './hosports-accessibility-widget.props.autogenerated';

export interface IHosportsAccessibilityWidgetViewProps extends IHosportsAccessibilityWidgetProps<IHosportsAccessibilityWidgetData> {

}

/**
 *
 * HosportsAccessibilityWidget component
 * @extends {React.PureComponent<IHosportsAccessibilityWidgetProps<IHosportsAccessibilityWidgetData>>}
 */
class HosportsAccessibilityWidget extends React.PureComponent<IHosportsAccessibilityWidgetProps<IHosportsAccessibilityWidgetData>> {
    public render(): JSX.Element | null {

        return this.props.renderView(this.props);
    }
}

export default HosportsAccessibilityWidget;
